export const CHOOSE_QUOTES_BAR_TEST_IDS = {
  BAR_WRAPPER: 'choose-quotes-bar-wrapper-test-id',
  QUOTE_SOURCE_RADIO: 'quote-source-radio-test-id',
  FINAL_SOURCE_RADIO: 'final-source-radio-test-id',
};

export const OVERRIDE_RATES_LOADING_SPINNER_TEST_ID = 'override-rates-loading-spinner';
